import { Component, OnInit, ViewChild } from '@angular/core';
import { ValidationService } from 'src/app/core/services/validation.service';
import { isValiddateNumber } from 'src/app/core/directives/country-flag-phone/country-flag-phone.directive';
import { AppService } from 'src/app/core/services/app.service';
import { API } from '../../../../core/constants';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { FormBuilder, FormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
const EMAIL_REGEX = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
declare let ga: Function;

@Component({
  selector: 'app-ic-contactus',
  templateUrl: './ic-contactus.component.html',
  styleUrls: ['./ic-contactus.component.scss']
})
export class IcContactusComponent implements OnInit {
  registerForm: FormGroup;
  userInfo: any = {};
  userInfoSubscription: Subscription;
  deviceData: Subscription;
  performerInfoSubscr: Subscription;
  settingsDataSubscription: Subscription;
  channelName: any;
  isICChannel = false;
  settingsData: any = {}
  routerevents: any;


  @ViewChild(FormGroupDirective, { static: false }) formGroupDirective: FormGroupDirective;
  organization_id: null;
  isRedirected: boolean = false;
  contactAddress: any = null;
  contactEmail: any = null;

  constructor(private formBuilder: FormBuilder,
    private appService: AppService,
    private toastr: ToastrService,
    private commonSubscribeService: CommanSubscribeService,
    public router: Router,
    private activeRoute: ActivatedRoute,private titleService: Title) {
    if (this.router.getCurrentNavigation().extras.state && this.router.getCurrentNavigation().extras.state.data) {
      this.isRedirected = true;
      this.filterOrgData(this.router.getCurrentNavigation().extras.state.data[0], this.isRedirected, this.router.getCurrentNavigation().extras.state.data[1], this.router.getCurrentNavigation().extras.state.data[2])
    } else {
      this.isRedirected = false;
    }
  }
  deviceType = ''

  ngOnInit() {
    this.settingsData = this.commonSubscribeService.icWebpageSettingsData;
    this.settingsDataSubscription = this.commonSubscribeService.getICWebpageThemeSettings().subscribe(response => {
      this.settingsData = response;
    });
    this.commonSubscribeService.getPerfomerInfo().subscribe(
      (response) => {
        this.titleService.setTitle(response.data.Data[0].channel_display_name);
      console.log("pagetitle",response,response.data.Data[0].channel_display_name);
        if (response.status == 200) {
          if (this.isRedirected == false) {
            let orgInfo
            this.organization_id = response.data.Data[0].organization_id
            orgInfo = response.data.Data[0].org_info
            this.filterOrgData(response.data.Data[0].org_info, this.isRedirected, response.data.Data[0].organization_id,
              response.data.Data[0].channel_name
            )
            //contact_address &&  contact_email
          }
        }
      },
      (error) => {
        console.log(error);
      }
    )
    this.buildForm();
  }

  buildForm() {
    this.registerForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: ["", [Validators.required, ValidationService.emailValidator, Validators.pattern(EMAIL_REGEX)]],
      phone: ['', [Validators.required, isValiddateNumber.isvalidNumber(false)]],
      message: ['', Validators.required],
      organization_name: ['']
    });
    if (this.activeRoute.snapshot.params.channelName) {
      try { ga('set', 'page', this.router.url); ga('send', 'pageview'); } catch (e) { }
    }
  }
  onSubmit() {
    if (this.registerForm.valid && this.organization_id) {
      let url = API.CONTACT_US;
      let inputData = this.registerForm.value;
      inputData['type'] = 'fan';  // this.channelName + this.deviceType;
      inputData['organization_id'] = this.organization_id;
      this.appService.postRequest(url, inputData).subscribe(result => {
        if (result.status == 0) {
          this.toastr.success(result.message);
          setTimeout(() =>
            this.formGroupDirective.resetForm(), 0);
          if (this.userInfo && this.userInfo.id)
            this.router.navigate([this.commonSubscribeService.getChannelBasePath(this.channelName)]);
          else
            this.router.navigate([this.commonSubscribeService.getChannelBasePath(this.channelName)]);
        }
      }, error => {
        console.log(error);
      })
    }
  }

  getPerformerInfo() {
    // console.log("Performer Calling")
    // this.deviceType = this.commonSubscribeService.deviceType;
    // this.settingsData = this.commonSubscribeService.icWebpageSettingsData;
    // this.settingsDataSubscription = this.commonSubscribeService.getICWebpageThemeSettings().subscribe(response => {
    //   this.settingsData = response;
    // });
    // if (this.router.url.toLowerCase().includes('indigenouscloud')) {
    //   this.isICChannel = true;
    // }


    // let perfomerInfoData = this.commonSubscribeService.perfomerInfoData;
    // if(perfomerInfoData && Object.keys(perfomerInfoData).length != 0) {
    //   perfomerInfoData = this.commonSubscribeService.perfomerInfoData;
    // }
    // this.channelName = perfomerInfoData.data? perfomerInfoData.data.Data[0].channel_name:'';
    // this.performerInfoSubscr = this.commonSubscribeService.getPerfomerInfo().subscribe(response => {
    //   perfomerInfoData =response;
    //   this.channelName = perfomerInfoData.data.Data[0].channel_name;
    //   //this.getContactDetails(perfomerInfoData.data.Data[0].organization_id);
    // })
    // this.userInfoSubscription = this.commonSubscribeService.getUserInfo().subscribe(response => {
    //   this.userInfo = response;
    // });
  }

  filterOrgData(orgData, isRedirected, orgId, channel) {
    this.organization_id = orgId;
    this.contactAddress = orgData.contact_address ? JSON.parse(orgData.contact_address) : "";
    this.contactEmail = orgData.contact_email;
    this.channelName = channel
    // console.log("ORG INFO: ",orgData)
    // console.log("ORG ID: ", this.organization_id)
  }

  ngOnDestroy() {
    if (this.userInfoSubscription)
      this.userInfoSubscription.unsubscribe();
  }

}
